import React, { useEffect, useState, useRef, RefObject } from 'react'
import { Box, Typography } from '@material-ui/core'
import { FormLabel, OutlinedInput } from '@material-ui/core'
import { IProps } from './Interface'
import classNames from 'classnames/bind'
import useStyles from './Styles'

const Input: React.FC<IProps> = ({
  id,
  limit,
  textSize,
  textColor,
  showLimit,
  onChanged,
  inputProps,
  placeholder,
  initialValue,
  displayHover,
  sanitizeValue,
  alwaysEnabled,
  onClick,
  onKeyPress,
  ...props
}) => {
  const [value, setValue] = useState(initialValue)

  useEffect(() => {
    setValue(initialValue)
  }, [initialValue])

  const { multiline, disabled, rows } = props
  const showCounter = Boolean(showLimit && !disabled && limit)

  const refInput: RefObject<any> = useRef(null)
  const classes = useStyles({
    rows,
    limit,
    textSize,
    textColor,
    multiline,
    showLimit,
    showCounter,
    displayHover,
    alwaysEnabled,
    disabled
  })
  const finalInputProps = { ...inputProps, 'data-testid': id }

  const handleChange = (evt: { target: { value: string } }) => {
    const sanitizedValue = sanitizeValue(value, evt.target.value)
    if (sanitizedValue.length <= limit) {
      setValue(sanitizedValue)
      onChanged(sanitizedValue)
    } else if (sanitizedValue.length > limit) {
      setValue(sanitizedValue.slice(0, limit))
      onChanged(sanitizedValue.slice(0, limit))
    }
  }

  const cx = classNames.bind(classes)
  const counter = showCounter && (
    <FormLabel className={classes.counter}>
      {`${value || []}`.length}/{limit}
    </FormLabel>
  )
  return (
    <Box className={classes.container} onClick={onClick}>
      {!disabled && (
        <OutlinedInput
          ref={refInput}
          id={id}
          className={classes.input}
          inputProps={finalInputProps}
          autoFocus
          value={value}
          fullWidth
          labelWidth={0}
          placeholder={placeholder}
          onChange={handleChange}
          onKeyPress={onKeyPress}
          endAdornment={counter}
          {...props}
        />
      )}

      {disabled && (
        <Typography
          className={cx({
            display: true,
            hover: displayHover,
            placeholder: !value || !value.trim().length
          })}
          id={`${id}-input-label`}
          data-testid={`${id}-input-label`}
        >
          {value || placeholder}
        </Typography>
      )}
    </Box>
  )
}

Input.defaultProps = {
  limit: 24,
  showLimit: false,
  textSize: 14,
  textColor: 'black',
  disabled: false,
  initialValue: '',
  rows: 3,
  displayHover: true,
  onChanged: value => value,
  sanitizeValue: (_value, newValue) => newValue,
  onBlur: () => {},
  alwaysEnabled: true,
  onClick: () => {}
}

export default Input
